






import { Component, Vue, Prop, Provide } from 'vue-property-decorator'

@Component
export default class Office extends Vue {
  @Prop() public url!: string
  public base = 'https://view.officeapps.live.com/op/embed.aspx?src='
  // public base = 'https://ow365.cn?n=5&furl='
}
